import { Grid, Skeleton, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { useAppState } from "../../hooks/useAppState";
import { ViewportActions } from "../../pages/Player/ViewportActions";
import { getReadableFromSeconds, getSecondsFromTimestamp } from "../../util/time";
import { useViewport, View } from "../Viewport/useViewport";
import { ModuleWrapper, StyledTypography } from "./Module.elements";
import { Select } from "./Select";

export function Module(): React.ReactElement | null {
  const { module } = useAppState();
  const { view } = useViewport();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { loading } = useAppState();

  if (module?.type !== "CONTENT" || view === View.Confidence) return null;

  // May need replacing in future with a state value
  const calculateTotalTime = () => {
    const totalTime: Array<number> = [];
    module.slides.forEach(slide => totalTime.push(getSecondsFromTimestamp(slide.duration)));
    const totalSeconds = totalTime.reduce((previousValue, currentValue) => previousValue + currentValue, 0);

    return getReadableFromSeconds(totalSeconds);
  };

  const SelectHeader = () => (
    <>
      {!module || loading.module ? (
        <Skeleton variant="text" sx={{ fontSize: "0.875rem", flex: 1 }} />
      ) : (
        <>
          <Grid size={{ xs: 12, md: 10 }}>
            <StyledTypography component="h3" bold>
              {`${module.fullNumber} ${module.name}`}
            </StyledTypography>
          </Grid>
          <Grid>
            <StyledTypography component="p" bold>
              {calculateTotalTime()}
            </StyledTypography>
          </Grid>
        </>
      )}
    </>
  );

  return (
    <>
      {!isMobile && (
        <Grid
          container
          id="module_title_details"
          sx={{ justifyContent: "space-between", marginBottom: theme.spacing(2) }}
        >
          <SelectHeader />
        </Grid>
      )}
      <ModuleWrapper>
        {loading.module ? (
          <Skeleton variant="rectangular" sx={{ height: "40px", flex: 1 }} />
        ) : (
          <>
            <Select data={module.slides} />
            <ViewportActions />
          </>
        )}
      </ModuleWrapper>
    </>
  );
}
